import React from 'react'
import LocalContentHeader from './Header'

function LocalContentView({ children }) {


  return (
    <div id="localContent" className="layout layout--information layout--border-top">
      <div className="layout__container layout--padding-top layout--padding-bottom">
        <div className="row layout__inner">
          <div className="columns layout__column layout__column--content">
            <LocalContentHeader />
            <div className="layout__container">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LocalContentView
